/* eslint-disable */
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col } from "antd";

//Styling
import {
  PageContent,
  StyledH3,
  StyledSection,
  BigYellowButton,
} from "./ReferralStyle";

//Components
import ReferralCodeCard from "./ReferralCodeCard";
import HowItWorkCard from "./HowItWorkCard";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Referral = () => {
  const { t, i18n } = useTranslation("referral");
  const { referralCode } = useParams();
  const displayLanguage = useQuery().get("lang");
  const refererName = useQuery().get("referer");

  const howItWorksTitle = [
    {
      title: "Visit Our Site",
    },
    {
      title: "Choose a plan",
    },
    {
      title: "Enter Code",
    },
  ];

  useEffect(() => {
    if (displayLanguage) i18n.changeLanguage(displayLanguage);
  }, [i18n]);

  return (
    <PageContent>
      <StyledSection justify="center" align="top">
        <Col xs={24} md={20} lg={10}>
          {referralCode && refererName ? (
            <ReferralCodeCard
              refererName={refererName}
              referralCode={referralCode}
            />
          ) : (
            <p style={{ color: "white", fontWeight: "bold" }}>
              {t("The URL is incorrect. Please try again.")}
            </p>
          )}
        </Col>
      </StyledSection>

      <StyledSection justify="center" align="top">
        <Col xs={24} md={13} xl={7}>
          <StyledH3 style={{ color: "#fff", marginBottom: 0 }}>
            {t("How it works").toUpperCase()}
          </StyledH3>
        </Col>
      </StyledSection>

      <StyledSection justify="center" align="top">
        <Col xs={24} xl={20}>
          <Row gutter={[20, 20]} justify="center" align="top">
            {howItWorksTitle.map((item, idx) => (
              <Col key={idx} xs={24} md={20} lg={8}>
                <HowItWorkCard order={idx + 1} title={item.title} />
              </Col>
            ))}
          </Row>
        </Col>
      </StyledSection>

      <StyledSection justify="center" align="top">
        <Col xs={24} md={20} lg={13} xl={7}>
          <BigYellowButton href="https://flexiclasses.com">
            {t("Visit flexi registration").toUpperCase()}
          </BigYellowButton>
        </Col>
      </StyledSection>
    </PageContent>
  );
};

export default Referral;
